import React, { Fragment } from 'react';

const Approvals = () => {
  return (
    <Fragment>
      <div className="stream-section-container">
        <div className="padding-container">
          <div className="title-container-info">
            <div className="border-alt red">
              <p className="online-title-alt red">Approvals</p>
            </div>
          </div>
          <div className="sponsors-container">
            <div className="sponsor"></div>
            <div className="sponsor"></div>
            <div className="sponsor"></div>
            <div className="sponsor"></div>
            <div className="sponsor"></div>
            <div className="sponsor"></div>
            <div className="sponsor"></div>
            <div className="sponsor"></div>
            <div className="sponsor"></div>
            <div className="sponsor"></div>
            <div className="sponsor"></div>
            <div className="sponsor"></div>
            <div className="sponsor"></div>
            <div className="sponsor"></div>
            <div className="sponsor"></div>
            <div className="sponsor"></div>
            <div className="sponsor"></div>
            <div className="sponsor"></div>
          </div>
        </div>
      </div>
      <div className="margin-top"></div>
    </Fragment>
  );
};

export default Approvals;
